export const LoreFocus = (props) => {
	
		return (
		<div className={"lore-focus lore-focus--" + props.on}>
			<h2><img src={props.lore.image}/><span>{props.lore.name}</span> </h2>
			
			<p className="lore-desc">{props.lore.description}</p>
			{(typeof props.lore.book != 'undefined') ? Object.values(props.lore.book[0]).map(x=><p>{x}</p>) : ""}
		</div>
		)}